import script from "./BtnBack.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnBack.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__